import { useEffect, useRef } from 'react';
import { createQr } from '../qr';

export interface QrViewProps {
    url: string;
    /** Pixel size of the drawing; CSS may scale the SVG (viewBox is kept). */
    size: number;
    /** Describes the code to screen readers. */
    label: string;
    className?: string;
}

/** Inline SVG code, pure black on white, so it prints the same on every printer. */
export const QrView = ({ url, size, label, className }: QrViewProps) => {
    const host = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const el = host.current;
        if (!el) return;
        el.replaceChildren();
        createQr(url, size).append(el);
        const svg = el.querySelector('svg');
        svg?.setAttribute('role', 'img');
        svg?.setAttribute('aria-label', label);
        svg?.removeAttribute('width');
        svg?.removeAttribute('height');
        svg?.setAttribute('style', 'width:100%;height:100%;display:block');
        return () => el.replaceChildren();
    }, [url, size, label]);
    return <div ref={host} className={className} />;
};
